import { v4 } from 'uuid';

export interface IBaseObject {
  id: number | string;
  uuid?: string;
}

export class BaseObject implements IBaseObject {
  id!: number | string;
  uuid?: string;

  get hasId(): boolean {
    return this.id != null && this.id !== -1 && (this.id as string).length > 0;
  }

  constructor(props: IBaseObject | undefined) {
    if (props) {
      this.id = props.id;
      this.uuid = props.uuid;
    }

    if (!this.uuid) {
      this.uuid = v4();
    }
  }
}
